Base = App.loadClass 'core::Services/MapLayers/Base'

exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.YieldMap', [
        '$http', 'Core.Services.Map', '$q', (args...) ->
            return {
                new: () ->
                    service = new exports.YieldMap(args...)
                    service.url = 'backend/grower/layers/shapefile/get-json'

                    return service
            }
    ]

class exports.YieldMap extends Base

    propertyTable: (ft, layer) =>
        if ft.properties?
            info = "
                <table class='table table-condensed margin-top-22'>
            "
            for k, v of ft.properties
                if k not in ['Crop', 'Yield', 'Area']
                    continue
                info += "<tr><td><strong>#{k}</strong></td><td>#{v}</td></tr>"

            info += '</table>'

        layer.bindPopup(info)
